import React, { useEffect, useMemo, useState } from "react";
import LayerAdmin from "../LayerAdmin";
import PaginationSearch from "../components/PaginationAndSearch";
import EmployeeTable from "../components/EmployeeTable";
import { getAllAuth } from "../api/auth";
import { useNavigate } from "react-router-dom";
import URL_MAPPING from "../../../routes/constants";
import { toast, ToastContainer } from "react-toastify";
import { useDebounce } from "../hooks/debounce";
import AuthTable from '../components/AuthTable'

const Auth = () => {
  const [tableData, setTableData] = useState<any>({});
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  const debounce = useDebounce(search);

  const getTableData = async () => {
    try {
      setLoading(true);
      const paramsObject: {
        search?: string[];
      } = {};
      if (search.length > 0) paramsObject.search = [search];
      const response = await getAllAuth(page, 20, paramsObject);
      if (!response || !Array.isArray(response.items)) {
        toast.error("No data received or malformed response");
        console.warn("No data received or malformed response:", response);
        setTableData({ items: [], page: 1, size: 20, total: 0 });
        return;
      }
      setTableData(response);
      setPage(response.page ?? 1);
    } catch (error: any) {
      console.error("Failed to fetch employee data:", error);
      if (error?.response?.status === 404) {
        toast.error("Route not found, Please try again later");
      } else if (error?.response?.status === 500) {
        toast.error("Error while fetching the employee");
      } else {
        const detail = error?.response?.data?.detail;
        if (Array.isArray(detail)) {
          detail.forEach((err) => toast.error(err.msg));
        } else {
          toast.error(detail?.msg || detail || "An unexpected error occurred.");
        }
      }
    } finally {
      setLoading(false);
    }
  };

  const handlePaginationNext = () => {
    if (loading) return;
    setPage((prev) => prev + 1);
  };

  const handlePaginationPrev = () => {
    if (loading) return;
    setPage((prev) => Math.max(prev - 1, 1));
  };

  const handleEditEmoloyee = (id: string) => {
    navigate(URL_MAPPING.EDITSALES(id));
  };

  const totalPages = useMemo(() => {
    if (!tableData?.total || !tableData?.size) return 0;
    return Math.ceil(tableData.total / tableData.size);
  }, [tableData?.total, tableData?.size]);

  useEffect(() => {
    getTableData();
  }, [page, debounce]);
  return (
    <LayerAdmin>
      <ToastContainer />
      <PaginationSearch
        page={page}
        size={totalPages}
        handlePaginationNext={handlePaginationNext}
        handlePaginationPrev={handlePaginationPrev}
        search={search}
        placeholder="Search By Name"
        setSearch={setSearch}
      />
     <div className="mb-4 px-5 flex items-end justify-between">
        <h3 className="text-xl font-bold text-gray-700">Roles</h3>
   
      
          <button
            onClick={() => navigate(URL_MAPPING.ADDRULES)}
              className="bg-teal-500 text-white px-6 py-2 rounded hover:bg-teal-600 flex items-center gap-2"
          >
            Add Roles
          </button>
          
       </div>
      <AuthTable
        tableData={tableData}
        loading={loading}
        handleEditEmoloyee={handleEditEmoloyee}
      />
    </LayerAdmin>
  );
};

export default Auth;
